import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type MyMultiFactorStatusFragment = { __typename?: 'MyMultiFactorStatus', applicationId: string, enabled: boolean, methods: Array<string>, mfaEnrollmentRequired: boolean, mfaEnrollmentBlocking: boolean, graceDeadline?: Types.TDateISO | null };

export type MultiFactorEnrollmentStartFragment = { __typename?: 'MultiFactorEnrollmentStart', secretBase32Encoded: string, otpAuthUri: string, issuer: string, accountName: string, algorithm: string, digits: number, periodSeconds: number };

export type TenantMultiFactorPolicyFragment = { __typename?: 'TenantMultiFactorPolicy', applicationId: string, requireMfa: boolean, graceWindowDays?: number | null, enabledAt?: Types.TDateISO | null, graceDeadline?: Types.TDateISO | null };

export type GetMyMultiFactorStatusQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMyMultiFactorStatusQuery = { __typename?: 'Query', myMultiFactorStatus: { __typename?: 'MyMultiFactorStatusPayload', status?: { __typename?: 'MyMultiFactorStatus', applicationId: string, enabled: boolean, methods: Array<string>, mfaEnrollmentRequired: boolean, mfaEnrollmentBlocking: boolean, graceDeadline?: Types.TDateISO | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type GetMyMultiFactorRecoveryCodesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMyMultiFactorRecoveryCodesQuery = { __typename?: 'Query', myMultiFactorRecoveryCodes: { __typename?: 'MultiFactorRecoveryCodesPayload', recoveryCodes?: Array<string> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type GetTenantMultiFactorPolicyQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetTenantMultiFactorPolicyQuery = { __typename?: 'Query', tenantMultiFactorPolicy: { __typename?: 'TenantMultiFactorPolicyPayload', policy?: { __typename?: 'TenantMultiFactorPolicy', applicationId: string, requireMfa: boolean, graceWindowDays?: number | null, enabledAt?: Types.TDateISO | null, graceDeadline?: Types.TDateISO | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export const MyMultiFactorStatusFragmentDoc = new TypedDocumentString(`
    fragment MyMultiFactorStatus on MyMultiFactorStatus {
  applicationId
  enabled
  methods
  mfaEnrollmentRequired
  mfaEnrollmentBlocking
  graceDeadline
}
    `, {"fragmentName":"MyMultiFactorStatus"});
export const MultiFactorEnrollmentStartFragmentDoc = new TypedDocumentString(`
    fragment MultiFactorEnrollmentStart on MultiFactorEnrollmentStart {
  secretBase32Encoded
  otpAuthUri
  issuer
  accountName
  algorithm
  digits
  periodSeconds
}
    `, {"fragmentName":"MultiFactorEnrollmentStart"});
export const TenantMultiFactorPolicyFragmentDoc = new TypedDocumentString(`
    fragment TenantMultiFactorPolicy on TenantMultiFactorPolicy {
  applicationId
  requireMfa
  graceWindowDays
  enabledAt
  graceDeadline
}
    `, {"fragmentName":"TenantMultiFactorPolicy"});
export const GetMyMultiFactorStatusDocument = new TypedDocumentString(`
    query GetMyMultiFactorStatus {
  myMultiFactorStatus {
    status {
      ...MyMultiFactorStatus
    }
    errors {
      code
      message
    }
  }
}
    fragment MyMultiFactorStatus on MyMultiFactorStatus {
  applicationId
  enabled
  methods
  mfaEnrollmentRequired
  mfaEnrollmentBlocking
  graceDeadline
}`);
export const GetMyMultiFactorRecoveryCodesDocument = new TypedDocumentString(`
    query GetMyMultiFactorRecoveryCodes {
  myMultiFactorRecoveryCodes {
    recoveryCodes
    errors {
      code
      message
    }
  }
}
    `);
export const GetTenantMultiFactorPolicyDocument = new TypedDocumentString(`
    query GetTenantMultiFactorPolicy {
  tenantMultiFactorPolicy {
    policy {
      ...TenantMultiFactorPolicy
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantMultiFactorPolicy on TenantMultiFactorPolicy {
  applicationId
  requireMfa
  graceWindowDays
  enabledAt
  graceDeadline
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetMyMultiFactorStatus: build.query<GetMyMultiFactorStatusQuery, GetMyMultiFactorStatusQueryVariables | void>({
      query: (variables) => ({ document: GetMyMultiFactorStatusDocument, variables })
    }),
    GetMyMultiFactorRecoveryCodes: build.query<GetMyMultiFactorRecoveryCodesQuery, GetMyMultiFactorRecoveryCodesQueryVariables | void>({
      query: (variables) => ({ document: GetMyMultiFactorRecoveryCodesDocument, variables })
    }),
    GetTenantMultiFactorPolicy: build.query<GetTenantMultiFactorPolicyQuery, GetTenantMultiFactorPolicyQueryVariables | void>({
      query: (variables) => ({ document: GetTenantMultiFactorPolicyDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetMyMultiFactorStatusQuery, useLazyGetMyMultiFactorStatusQuery, useGetMyMultiFactorRecoveryCodesQuery, useLazyGetMyMultiFactorRecoveryCodesQuery, useGetTenantMultiFactorPolicyQuery, useLazyGetTenantMultiFactorPolicyQuery } = injectedRtkApi;
